// 検索条件を共有するためのState (URLへの反映は別途)
import type { BoothSearchParamForState } from "~/types/entity/cWebCatalog";

const getDefaultValue = (): BoothSearchParamForState => ({
  keyword: undefined,
  searchBoothName: true,
  searchExhibitionDetails: true,
});

export const useBoothSearchState = () => {
  const state = useState<BoothSearchParamForState>("boothSearchParamForState", getDefaultValue);

  const reset = () => {
    state.value = getDefaultValue();
  };

  // アプリケーション内でグローバルな state の操作は影響範囲が大きいので 手軽に使える値の操作として公開せず
  // 関数呼び出しとして見せる
  return {
    /**
     * パラメータとして取得する
     */
    get: () => state.value,
    /**
     * パラメータを更新する
     * @param v
     * @returns
     */
    set: (v: BoothSearchParamForState) => state.value = v,
    /**
     * 初期状態に戻す
     * ただし一部の値を維持することがある (例えば event_id)
     *
     * 1関数内で 他の値設定を続いて呼び出した場合 画面の再描画されないことが期待できる
     */
    reset,
  };
};
